import { createAction, props } from '@ngrx/store';

const GET_ALL_USERSTORIES = '[generationsUserStories] Get All UserStories';
const CREATE_USERSTORY = '[generationsUserStories] Create UserStory';
const UPDATE_USERSTORY = '[generationsUserStories] Update UserStory';
const DELETE_USERSTORY = '[generationsUserStories] Delete UserStory';
const CREATE_USERSTORY_SUCCESS = '[generationsUserStories] Create UserStory Success';
const CREATE_USERSTORY_FAILURE = '[generationsUserStories] Create UserStory Failure';
const RESET_USERSTORIES_STATE = '[generationsUserStories] Reset UserStories State';
const SET_NORMALIZED_DATA = '[generationsUserStories] Set Normalized Data';
const ADD_USERSTORY_IN_STATE = '[generationsUserStories] Add UserStory In State';
const DELETE_USERSTORY_IN_STATE = '[generationsUserStories] Delete UserStory In State';
const UPDATE_USERSTORY_IN_STATE = '[generationsUserStories] Update UserStory In State';

const getAllUserStories = createAction(GET_ALL_USERSTORIES, props<{ apiConstants: any; urlPathVariables: any }>());
const createUserStory = createAction(CREATE_USERSTORY, props<{ apiConstants: any; data: any }>());
const createUserStorySuccess = createAction(CREATE_USERSTORY_SUCCESS, props<{ data: any }>());
const createUserStoryFailure = createAction(CREATE_USERSTORY_FAILURE, props<{ error: any }>());
const updateUserStory = createAction(UPDATE_USERSTORY, props<{ apiConstants: any; data: any }>());
const deleteUserStory = createAction(
  DELETE_USERSTORY,
  props<{ apiConstants: any; urlPathVariables: { componentId: string } }>()
);
const resetUserStoriesState = createAction(RESET_USERSTORIES_STATE);
const setNormalizedData = createAction(SET_NORMALIZED_DATA, props<{ data: any }>());
const updateUserStoryInState = createAction(UPDATE_USERSTORY_IN_STATE, props<{ data: any }>());
const addUserStoryInState = createAction(ADD_USERSTORY_IN_STATE, props<{ data: any }>());
const deleteUserStoryInState = createAction(DELETE_USERSTORY_IN_STATE, props<{ id: string }>());

const UserStoryActions = {
  getAllUserStories,
  createUserStory,
  createUserStorySuccess,
  createUserStoryFailure,
  updateUserStory,
  deleteUserStory,
  resetUserStoriesState,
  setNormalizedData,
  addUserStoryInState,
  deleteUserStoryInState,
  updateUserStoryInState
};

export default UserStoryActions;
